import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import * as Auth from "../store/ducks/auth.duck";
import * as Admin from "../store/ducks/admin.duck";

export default function useSearchStringRedirect() {
  const dispatch = useDispatch();
  const history = useHistory();

  const searchString = useSelector((state) => state.auth.SearchString);

  useEffect(() => {
    if (!searchString) return;

    const params = new URLSearchParams(searchString);

    const clientId = params.get("client");
    const csClientId = params.get("csclient");
    const providerClient = params.get("providerclient");
    const page = params.get("page");

    // console.log("useSearchStringRedirect: clientId:", clientId);
    // console.log("useSearchStringRedirect: csClientId:", csClientId);
    // console.log("useSearchStringRedirect: providerClient:", providerClient);
    // console.log("useSearchStringRedirect: page:", page);

    // Clear it first so it cannot fire again
    dispatch(Auth.actions.clearSearchString());

    if (clientId) {
      dispatch(
        Admin.actions.setFilters({
          filterName: "clientsListLoadClientID",
          filterValue: clientId,
        }),
      );

      if (page) {
        dispatch(
          Admin.actions.setFilters({
            filterName: "clientsListLoadModalID",
            filterValue: page,
          }),
        );
      }

      history.push("/psychologyclients");
    }

    if (csClientId) {
      dispatch(
        Admin.actions.setFilters({
          filterName: "clientsListLoadClientID",
          filterValue: csClientId,
        }),
      );

      if (page) {
        dispatch(
          Admin.actions.setFilters({
            filterName: "clientsListLoadModalID",
            filterValue: page,
          }),
        );
      }

      history.push("/csclients");
    }

    if (providerClient) {
      dispatch(
        Admin.actions.setFilters({
          filterName: "clientsListLoadClientID",
          filterValue: providerClient,
        }),
      );

      if (page) {
        dispatch(
          Admin.actions.setFilters({
            filterName: "clientsListLoadModalID",
            filterValue: page,
          }),
        );
      }
      history.push("/Clients");
    }
  }, [searchString, dispatch, history]);
}
